import request from './request';
import { accountingApi, agentAccountingApi, workbenchApi } from './accounting';
import { analysisApi, agentStatsApi } from './analysis';
import monitorApi from './monitor';
import { scheduleApi } from './schedules';
import { fileCategoryApi } from './fileCategories';

export { accountingApi, agentAccountingApi, workbenchApi, analysisApi, agentStatsApi, monitorApi, scheduleApi, fileCategoryApi };

export const authApi = {
  login: (data) => request.post('/auth/login', data),
  getCurrentUser: () => request.get('/auth/me'),
  changePassword: (data) => request.post('/auth/change-password', data),
  refreshToken: () => request.post('/auth/refresh')
};

export const orderApi = {
  // 管理员接口
  getList: (params) => request.get('/orders', { params }),
  getById: (id) => request.get(`/orders/${id}`),
  create: (data) => request.post('/orders', data),
  update: (id, data) => request.patch(`/orders/${id}`, data),
  delete: (id) => request.delete(`/orders/${id}`),
  batchUpdate: (data) => request.post('/orders/batch', data),
  getStats: (params) => request.get('/orders/stats', { params }),

  // 代投员接口
  getMyTasks: (params) => request.get('/orders/my-tasks', { params }),
  getCustomerSuggest: (params) => request.get('/orders/customer-suggest', { params }),
  assignMe: (id) => request.post(`/orders/${id}/assign-me`),
  updateMyTaskMeta: (orderId, data) => request.post(`/orders/${orderId}/my-task-meta`, data),

  // 订单代投人管理接口
  getDeliveryAgents: (orderId) => request.get(`/orders/${orderId}/delivery-agents`),
  addDeliveryAgent: (orderId, data) => request.post(`/orders/${orderId}/delivery-agents`, data),
  updateDeliveryAgent: (orderId, agentId, data) => request.put(`/orders/${orderId}/delivery-agents/${agentId}`, data),
  removeDeliveryAgent: (orderId, agentId, data) => request.delete(`/orders/${orderId}/delivery-agents/${agentId}`, { data }),
  setPrimaryAgent: (orderId, agentId) => request.put(`/orders/${orderId}/primary-agent/${agentId}`),
  unassignPrimary: (orderId, data) => request.post(`/orders/${orderId}/unassign-primary`, data),
  transferPrimary: (orderId, data) => request.post(`/orders/${orderId}/transfer-primary`, data),

  // 导入接口
  previewImport: (data) => request.post('/orders/import/preview', data),
  import: (data) => request.post('/orders/import', data),
  
  // 清空全部订单
  deleteAll: () => request.delete('/orders/all'),
  
  // 获取订单变更历史
  getChangeLogs: (orderId, params) => request.get(`/orders/${orderId}/change-logs`, { params }),

  // 同步备注到客户（事务性操作）
  syncRemarks: (orderId, data) => request.post(`/orders/${orderId}/sync-remarks`, data),

  // 投递统计
  getMyDeliveryStats: (params) => request.get('/orders/my-delivery-stats', { params }),
  getTeamDeliveryStats: () => request.get('/orders/team-delivery-stats'),

  // 按组统计代投员订单星级分布
  getDeliveryStatsByGroup: (params) => request.get('/orders/delivery-stats-by-group', { params }),

  // 团队每日投递明细（管理员专用）
  getTeamDailyDetail: (params) => request.get('/orders/team-daily-detail', { params }),

  // 作废订单
  cancel: (id, data) => request.post(`/orders/${id}/cancel`, data),
  
  // 恢复作废订单
  restoreCancelled: (id) => request.post(`/orders/${id}/restore-cancelled`),
  
  // 获取作废订单列表
  getCancelledList: (params) => request.get('/orders', { params: { ...params, includeCancelled: true } }),

  // 月份投递明细
  getDeliveryMonthly: (orderId, agentId) => request.get(`/orders/${orderId}/delivery-monthly`, { params: agentId ? { agent_id: agentId } : {} }),
  updateDeliveryMonthly: (orderId, agentId, data) => request.put(`/orders/${orderId}/delivery-agents/${agentId}/monthly`, data),
  reportDeliveryMonthly: (orderId, data) => request.post(`/orders/${orderId}/report-monthly`, data),
  setDeliveryMonthly: (orderId, data) => request.put(`/orders/${orderId}/delivery-monthly`, data),
  deleteDeliveryMonthly: (orderId, data) => request.delete(`/orders/${orderId}/delivery-monthly`, { data })
};

// 归档订单API
export const archivedOrderApi = {
  getList: (params) => request.get('/orders', { params: { ...params, archived: true } }),
  reactivate: (id) => request.post(`/orders/${id}/reactivate`)
};

export const userApi = {
  getList: (params) => request.get('/users', { params }),
  getById: (id) => request.get(`/users/${id}`),
  create: (data) => request.post('/users', data),
  update: (id, data) => request.put(`/users/${id}`, data),
  delete: (id) => request.delete(`/users/${id}`),
  getDeliveryList: (leaderId, keyword, currentUserId, excludeIds) => request.get('/users/delivery/list', { params: { leader_id: leaderId, keyword, current_user_id: currentUserId, exclude_ids: excludeIds } }),
  getAllDeliveryList: (excludeIds, keyword) => request.get('/users/delivery/all', { params: { exclude_ids: excludeIds, keyword } }), // 获取所有代投员（不排除组长）
  getAdminList: () => request.get('/users/admin/list'),
  getLeaderList: () => request.get('/users/leader/list'), // 获取组长列表
  getManagerList: () => request.get('/users/admin/list'), // 总交付人使用管理员列表
  // 检查用户名是否存在（可被其他地方复用）
  checkUsernameExists: (username) => request.get('/users/check-username', { params: { username } }),
  // 根据用户名重置密码（仅管理员可用）
  resetPassword: (username) => request.post('/users/reset-password', { username })
};

export const roleApi = {
  getList: () => request.get('/roles'),
  getById: (id) => request.get(`/roles/${id}`),
  create: (data) => request.post('/roles', data),
  update: (id, data) => request.put(`/roles/${id}`, data),
  delete: (id) => request.delete(`/roles/${id}`),
  getPermissions: () => request.get('/roles/permissions'),
  updateRolePermissions: (roleId, data) => request.put(`/permissions/role/${roleId}`, data)
};

export const notificationApi = {
  getList: (params) => request.get('/notifications', { params }),
  getUnreadCount: () => request.get('/notifications/unread-count'),
  markAsRead: (id) => request.post(`/notifications/mark-read/${id || ''}`),
  markAllAsRead: () => request.post('/notifications/mark-all-read'),
  delete: (id) => request.delete(`/notifications/${id || ''}`),
  deleteAll: () => request.delete('/notifications/all/clear'),
  send: (data) => request.post('/notifications/send', data)
};

export const exportApi = {
  // 导出订单为 CSV
  exportOrders: (params) => request.post('/exports/orders/csv', params, {
    responseType: 'blob'
  }),
  // 导出月度账单 ZIP
  exportMonthlyBills: (year, month) => request.get('/exports/monthly-bills', {
    params: { year, month },
    responseType: 'blob'
  }),
  // 导出投递员结账数据
  exportDeliveryPayment: (year, month) => request.get('/exports/delivery-payment', {
    params: { year, month },
    responseType: 'blob'
  })
};

export const claimApi = {
  // 确认/拒绝抢单
  confirmClaim: (id, action, reason) => request.post(`/claims/${id}/confirm-claim`, { action, reason }),
  // 获取待确认的抢单列表
  getPendingClaims: () => request.get('/claims/pending-claims')
};

export const configApi = {
  // 获取所有配置
  getAll: () => request.get('/configs'),
  // 获取指定类型配置
  getByType: (type) => request.get(`/configs/type/${type}`),
  // 获取单个配置
  getValue: (key) => request.get(`/configs/${key}`),
  // 保存配置
  save: (data) => request.post('/configs', data),
  // 删除配置
  delete: (id) => request.delete(`/configs/${id}`),
  // 获取枚举选项列表
  getEnumOptions: (key) => request.get(`/configs/enum/${key}`),
  // 添加枚举选项
  addEnumItem: (key, value) => request.post(`/configs/enum/${key}`, { value }),
  // 更新枚举选项
  updateEnumItem: (key, oldValue, value) => request.put(`/configs/enum/${key}/${encodeURIComponent(oldValue)}`, { value }),
  // 删除枚举选项
  deleteEnumItem: (key, value) => request.delete(`/configs/enum/${key}/${encodeURIComponent(value)}`)
};

export const leaderApi = {
  // 获取团队成员列表
  getTeamMembers: () => request.get('/leaders/team-members'),
  // 获取待确认的抢单列表
  getPendingClaims: () => request.get('/leaders/pending-claims'),
  // 确认/拒绝抢单
  confirmClaim: (id, action, reason) => request.post(`/leaders/confirm-claim/${id}`, { action, reason }),
  // 获取团队业绩统计
  getTeamStats: () => request.get('/leaders/team-stats')
};

export const backupApi = {
  // 获取备份列表
  getList: (params) => request.get('/backups', { params }),
  // 获取备份统计
  getStats: () => request.get('/backups/stats'),
  // 创建备份
  create: (data) => request.post('/backups', data),
  // 获取备份详情
  getDetail: (id) => request.get(`/backups/${id}`),
  // 下载备份
  download: (id) => request.get(`/backups/${id}/download`, {
    responseType: 'blob'
  }),
  // 验证备份
  verify: (id) => request.post(`/backups/${id}/verify`),
  // 恢复备份
  restore: (id) => request.post(`/backups/${id}/restore`, {}, { timeout: 600000 }),
  // 删除备份
  delete: (id) => request.delete(`/backups/${id}`)
};

export const systemApi = {
  // 获取结账冻结状态
  getFreezeStatus: () => request.get('/system/freeze-status'),
  // 切换结账冻结状态（仅超管）
  toggleFreeze: (frozen) => request.post('/system/freeze', { frozen }),
  // 设置冻结月份（仅超管）
  setFreezeMonth: (month) => request.post('/system/freeze-month', { month }),
  // 获取数据一致性告警列表
  getDataAlerts: (params) => request.get('/system/data-alerts', { params }),
  // 获取告警统计
  getDataAlertStats: () => request.get('/system/data-alerts/stats'),
  // 更新告警状态
  updateDataAlertStatus: (id, data) => request.put(`/system/data-alerts/${id}/status`, data),
  // 手动触发巡检
  runDataAlertCheck: () => request.post('/system/data-alerts/run-check')
};

// 数据一致性管理API
export const dataConsistencyApi = {
  // 检查数据一致性
  check: () => request.get('/system/data-consistency/check'),
  // 导出核对表
  export: () => request.get('/system/data-consistency/export', { responseType: 'blob' }),
  // 执行修复
  fix: (data) => request.post('/system/data-consistency/fix', data)
};

export const customerApi = {
  // 获取客户列表
  getList: (params) => request.get('/customers', { params }),
  // 获取客户详情
  getById: (id) => request.get(`/customers/${id}`),
  // 创建客户
  create: (data) => request.post('/customers', data),
  // 更新客户
  update: (id, data) => request.put(`/customers/${id}`, data),
  // 删除客户
  delete: (id) => request.delete(`/customers/${id}`),
  // 获取客户统计
  getStats: () => request.get('/customers/stats'),
  // 批量转移客户
  transfer: (data) => request.post('/customers/transfer', data),
  // 获取客户资料包
  getPackage: (id) => request.get(`/customers/${id}/package`),
  // 打包下载客户资料（返回 JSON 包含下载链接）
  downloadPackage: (id) => request.get(`/customers/${id}/package/download`, { timeout: 120000 }),
  // 使资料包缓存失效（上传文件后调用）
  invalidatePackageCache: (id) => request.post(`/customers/${id}/invalidate-package`),
  // 导入预览
  previewImport: (data) => request.post('/customers/import/preview', data),
  // 确认导入
  import: (data) => request.post('/customers/import', data),
  // 同步备注到订单
  syncRemarksToOrders: (customerId, data) => request.post(`/customers/${customerId}/sync-remarks`, data)
};

export const fileApi = {
  // 删除文件
  delete: (id) => request.delete(`/files/${id}`),
  // 获取 COS STS 临时凭证
  getSTSToken: () => request.get('/files/sts-token'),
  // 前端直传 COS 后的回调
  directUploadCallback: (data) => request.post('/files/direct-upload-callback', data)
};

// 便捷导出监控API
export const {
  getDashboard,
  getMetrics,
  getMonitorStatus,
  getHealth,
  getLogs
} = monitorApi;
